import { connect } from 'react-redux'
import { getPostDischarges90dList } from '../actions/actions-postdischarges'
import { getProgramsAssignedToLoginList } from '../actions/actions-programs'
import PostDischarges90d from '../views/PostDischarges/postdischarges90d'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    postdischarges: state.postdischargesR.dataList,
    programsAssigned: state.programsR.programsassignedtologin
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getPostDischarges: loginID => {
      dispatch(getPostDischarges90dList(loginID))
    },
    getProgramsAssignedToLoginList: id => {
      dispatch(getProgramsAssignedToLoginList(id))
    }
  }
}
const PostDischarge90dListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostDischarges90d)
export default PostDischarge90dListContainer
